import { render, staticRenderFns } from "./DashboardCashInFlowNumberDisplayer.vue?vue&type=template&id=3478a57e"
import script from "./DashboardCashInFlowNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./DashboardCashInFlowNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports